import { render, staticRenderFns } from "./ArrayReorderBtnGroup.vue?vue&type=template&id=57053939&scoped=true"
import script from "./ArrayReorderBtnGroup.vue?vue&type=script&lang=js"
export * from "./ArrayReorderBtnGroup.vue?vue&type=script&lang=js"
import style0 from "./ArrayReorderBtnGroup.vue?vue&type=style&index=0&id=57053939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57053939",
  null
  
)

export default component.exports